import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import PricingOptions from '../../Common/PricingOptions/PricingOptions';
import PricingOptionsButtons from '../../Common/PricingOptionsButtons/PricingOptionsButtons';
import { SetComponentLanguage } from '../../../helpers';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import LocalizedStrings from 'react-localization';
import en from './locales/en.json';
import fr from './locales/fr.json';
import './EventPriceOptionsModal.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class EventPriceOptionsModal extends Component {
    constructor(props) {
        super(props);
    }

    renderCustomerName = () => {
        // Get Customer name with SeatId
        if (this.props.type === 'held' || this.props.type === 'sold' || this.props.type === 'reserved') {
            return (
                <div className="showtix-seat-box">
                    Customer Name: <Link to={`/search/transaction/${this.props.transactionId}`}>{this.props.customerName || "Transaction"}</Link>
                </div>
            )
        }
    }

    renderSeatName = () => {
        if (this.props.section_name && this.props.row_name && this.props.seat_name) {
            return (
                <React.Fragment>
                    <h4 className="modal-subtitle">{strings.section}{this.props.section_name} - {strings.row}{this.props.row_name} - {strings.seat}{this.props.seat_name}</h4>
                    <p>Is this seat a social distance seat? {this.props.is_social_distance ? 'Yes' : 'No'}</p>
                </React.Fragment>
            )
        } else {
            return null;
        }
    };

    getSeatType = () => {
        const seatType = this.props.pricingOptions[0].seat_type;
        return seatType || '';
    }

    renderAddCart = () => {
        if (this.props.type !== 'sold' && this.props.type !== 'held') {
            return (
                <React.Fragment>
                    <h5 className="modal-title" style={{marginBottom: '10px'}}>{strings.title}</h5>
                    <div className="xshowtix-form__group">
                        <div className="xshowtix-form__select">
                            {this.props.pricingOptions.length > 0 
                                ?
                                <React.Fragment>
                                    <PricingOptionsButtons
                                        value={this.props.currentPrice.id}
                                        pricingOptions={this.props.pricingOptions}
                                        user={this.props.user}
                                        handleChange={this.props.handlePriceChange}
                                    />
                                    {/* <select className="showtix-input"
                                        value={this.props.currentPrice.id}
                                        onChange={this.props.handlePriceChange}>
                                        <PricingOptions pricingOptions={this.props.pricingOptions} user={this.props.user} />
                                    </select>  */}
                                </React.Fragment>    
                                :
                                <h2>{strings.unavailable}</h2>
                            }
                        </div>
                    </div>
                </React.Fragment>    
            );
        }
    }

    renderModalButtons = () => {
        if (this.props.type !== 'sold' && this.props.type !== 'held') {
            return (
                <React.Fragment>
                    <button 
                        className="showtix-button showtix-background__grey-1"
                            onClick={this.props.toggleEventPriceOption}
                        >{strings.cancel}</button>
                    {/* <button 
                        className="showtix-button showtix-background__primary-3"
                            onClick={this.props.confirmEventPriceOption}
                            //if user is a patron, or a box-office user shopping outside their own events (acting as patron)
                            //then check if any pricing options are available for 'all' (patrons)
                            disabled={(this.props.user.role !== 'admin' && this.props.user.role !== 'box-office' && this.props.user.role !== 'client')
                                && !this.props.pricingOptions.some(price => price.value === 'all' || price.visibility === 'all')}
                    >{strings.addToCart}</button> */}
                </React.Fragment>  
            );
        } else {
            return (
                <button 
                    className="showtix-button showtix-background__grey-1"
                        onClick={this.props.toggleEventPriceOption}
                    >{strings.cancel}</button>
            );
        }
    }
    
	render() {
	  	return (
			<div>
                <Modal isOpen={this.props.isEventPriceOptionsOpen} toggle={this.props.toggleEventPriceOption}>
                    <ModalHeader toggle={this.props.toggleEventPriceOption}>
                        
                    </ModalHeader>
		          	<ModalBody>
                        {this.props.pricingOptions.length &&
                            <h5 className="modal-title" style={{marginBottom: '10px'}}>
                                {strings[this.getSeatType()] && strings[this.getSeatType()].value}
                            </h5>     
                        }
                        {this.renderSeatName()}
                        {this.props.pricingOptions.length &&
                            strings[this.getSeatType()] && <p>{strings[this.getSeatType()].description}</p>
                        }
                        {this.renderCustomerName()}
                        {this.renderAddCart()}
                    </ModalBody>
		          	<ModalFooter className="justify-content-center">
                        {this.renderModalButtons()}
		          	</ModalFooter>
		        </Modal>
			</div>
	  	);
	}
}

EventPriceOptionsModal.propTypes = {
    isDeleteEventOpen: PropTypes.bool,
    toggleConfirmDeleteEvent: PropTypes.func,
    confirmConfirmDeleteEvent: PropTypes.func,
}

export default EventPriceOptionsModal;


// WEBPACK FOOTER //
// ./src/components/Common/EventPriceOptionsModal/EventPriceOptionsModal.js